// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1574":"0d6282c7","5589":"a031e25e"}[chunkId] + ".chunk.css";
};